import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

export const selectProfileState = createSelector(
  (state: RootState) => state.profile,
  (profileState) => profileState
);

export const selectProfileData = createSelector(
  selectProfileState,
  (profile) => profile.data
);

export const selectBusiness = createSelector(
  selectProfileData,
  (profile) => profile?.company
);

export const selectNaturalPerson = createSelector(
  selectProfileData,
  (profile) => profile?.naturalPerson
);
